import styled from "styled-components";

export const Timestamp = styled.span`
  color: ${({ theme }) => theme.prevColors.blackLight};
`;
